import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import EmissionValueWithSuffix from '../../../../../../../../../../../../../../shared/components/emission-value-with-suffix/EmissionValueWithSuffix';
import { EmissionSymbol } from '../../../../../../../../../../../../../../shared/interfaces/IFootprint';
import { IInputMaterial } from '../../../../../../PcfWizard.type';
import RemoveButton from '../../../../RemoveButton';
import InputMaterialFieldsForm from '../input-material-fields-form/InputMaterialFieldsForm';
import styles from './InputMaterialCard.module.css';

interface InputMaterialCardProps {
  inputMaterial: IInputMaterial;
  /** Path of this material, e.g. `processes[0].input_materials[2]`. */
  formPath: string;
  processIndex: number;
  onRemove: () => void;
}

const InputMaterialCard = ({
  inputMaterial,
  formPath,
  processIndex,
  onRemove,
}: InputMaterialCardProps) => {
  const { t } = useTranslation();

  return (
    <div className='p-3 border-round-2xl bg-dark-gray mb-3'>
      <div className='flex flex-row justify-content-between gap-3'>
        <div className='flex flex-column'>
          <Tag
            rounded
            className={classNames(
              'font-medium w-fit',
              inputMaterial?.product_cid ? styles['component-id-tag'] : styles['manual-entry-tag'],
            )}
          >
            {inputMaterial?.product_cid ??
              t(
                'footprintDetailsPage.sections.calculatePcfSection.inputMaterialSection.manualEntryBadge',
              )}
          </Tag>
          <span className='text-2xl font-medium mb-0'>{inputMaterial?.material_name}</span>
          <RemoveButton onClick={onRemove} />
        </div>

        <div className='flex flex-column min-h-max min-w-max justify-content-center'>
          <EmissionValueWithSuffix
            emissionValue={inputMaterial?.pcf_excluding_biogenic}
            declaredUnit={inputMaterial?.declared_unit}
            unitaryProductAmount={inputMaterial?.unitary_product_amount}
            emissionSymbol={EmissionSymbol.KG_CO2E}
            abbreviateUnit={true}
            emissionValueDecimals={6}
            numericalValueTextClassName='text-2xl font-bold'
            suffixTextClassName='text-gray-900'
          />
        </div>
      </div>

      <Divider layout='horizontal' />

      <InputMaterialFieldsForm formPath={formPath} processIndex={processIndex} />
    </div>
  );
};

export default InputMaterialCard;
